import { Modal } from 'bootstrap';

export default function initMailchimp() {
    const inlineForm = document.getElementById('newsletter-inline-form');
    const inlineEmail = document.getElementById('FooterNewsletter');
    const openBtn = document.getElementById('button-subscribe-newsletter');

    const modalEl = document.getElementById('newsletterModal');
    if (!modalEl) return;

    const bsModal = Modal.getOrCreateInstance(modalEl);
    const modalForm = document.getElementById('newsletter-modal-form');
    if (!modalForm) return;

    const nmEmail = document.getElementById('nm_email');
    const nmFname = document.getElementById('nm_fname');
    const nmLname = document.getElementById('nm_lname');
    const nmOrg = document.getElementById('nm_org');
    const nmCountry = document.getElementById('nm_country');
    const nmSubmit = document.getElementById('nm_submit');
    const honeypot = modalForm.querySelector('input[name="website"]');

    const alertBox = document.getElementById('newsletter-modal-alert');
    const consentGroup = document.getElementById('consent-group');

    const submitSpinner = nmSubmit?.querySelector('.spinner-grow');
    const submitLabel = nmSubmit?.querySelector('.btn-label');

    // -----------------------
    // Alerts (Bootstrap)
    // -----------------------
    function hideAlert() {
        if (!alertBox) return;
        alertBox.classList.add('d-none');
        // pulizia classi/markup
        alertBox.classList.remove(
            'alert-success',
            'alert-danger',
            'alert-warning',
            'alert-info',
            'fade',
            'show',
            'alert-dismissible'
        );
        alertBox.innerHTML = '';
    }

    function showAlert(type, message) {
        if (!alertBox) return;

        alertBox.classList.remove('alert-success', 'alert-danger', 'alert-warning', 'alert-info');
        alertBox.classList.add('alert', 'alert-dismissible', 'fade', 'show', `alert-${type}`);
        alertBox.classList.remove('d-none');

        alertBox.innerHTML = `
      <div>${message}</div>
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    `;

        // porta l'attenzione all'alert (specialmente su mobile)
        alertBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    // -----------------------
    // Submit UI lock + spinner
    // -----------------------
    function setSubmitting(isSubmitting) {
        if (!modalForm || !nmSubmit) return;

        // disabilita tutti i controlli del form
        modalForm.querySelectorAll('input, select, textarea, button').forEach((el) => {
            el.disabled = isSubmitting;
        });

        // lascia attivo il close / cancel (se presenti)
        modalForm.querySelectorAll('[data-bs-dismiss]').forEach((el) => {
            el.disabled = false;
        });

        // spinner + testo
        if (submitSpinner) submitSpinner.classList.toggle('d-none', !isSubmitting);
        if (submitLabel) submitLabel.textContent = isSubmitting ? 'Submitting…' : 'Confirm subscription';
    }

    // -----------------------
    // Email validation (inline)
    // -----------------------
    function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
    }

    function inlineValidateEmail() {
        if (!inlineEmail) return false;
        const val = inlineEmail.value.trim();
        const ok = isValidEmail(val);
        inlineEmail.classList.toggle('is-invalid', !ok);
        inlineEmail.classList.toggle('is-valid', ok);
        return ok;
    }

    // -----------------------
    // Consent validation (radio)
    // -----------------------
    function setConsentValidity(isValid) {
        if (!consentGroup) return;

        consentGroup.classList.toggle('is-invalid', !isValid);

        // invalid-feedback appare solo quando form è "was-validated"
        const msg = document.getElementById('consent-invalid');
        if (msg) {
            msg.style.display = (!isValid && modalForm.classList.contains('was-validated')) ? 'block' : 'none';
        }
    }

    // nascondi errore consenso appena l'utente seleziona una radio (una volta sola)
    modalForm.querySelectorAll('input[name="consent"]').forEach((r) => {
        r.addEventListener('change', () => setConsentValidity(true));
    });

    // -----------------------
    // Countries lazy-load (name-only)
    // -----------------------
    async function loadCountriesOnce() {
        if (!nmCountry) return;
        if (nmCountry.dataset.countriesLoaded === '1') return;

        const defaultPlaceholder = 'Select a country (optional)';
        const loadingPlaceholder = 'Loading countries...';

        nmCountry.disabled = true;

        // placeholder loading
        nmCountry.innerHTML = '';
        const loadingOption = document.createElement('option');
        loadingOption.value = '';
        loadingOption.textContent = loadingPlaceholder;
        nmCountry.appendChild(loadingOption);

        try {
            const payload = new URLSearchParams();
            payload.append('action', 'fsr_newsletter_countries');
            payload.append('nonce', FSR_AJAX?.nonce || '');

            const res = await fetch(FSR_AJAX?.ajax, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                body: payload.toString(),
                credentials: 'same-origin',
            });

            const data = await res.json();
            if (!data?.success || !Array.isArray(data.data?.countries)) {
                throw new Error('Invalid countries payload');
            }

            nmCountry.innerHTML = '';

            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.textContent = defaultPlaceholder;
            nmCountry.appendChild(placeholder);

            for (const name of data.data.countries) {
                const opt = document.createElement('option');
                opt.value = name;      // value = name
                opt.textContent = name;
                nmCountry.appendChild(opt);
            }

            nmCountry.dataset.countriesLoaded = '1';
        } catch (e) {
            // fallback
            console.error(e);
            nmCountry.innerHTML = '';
            const errorOption = document.createElement('option');
            errorOption.value = '';
            errorOption.textContent = 'Unable to load countries';
            nmCountry.appendChild(errorOption);
        } finally {
            nmCountry.disabled = false;
        }
    }

    // trigger lazy-load (una sola volta)
    nmCountry?.addEventListener('focus', loadCountriesOnce, { once: true });
    nmCountry?.addEventListener('mousedown', loadCountriesOnce, { once: true });

    // -----------------------
    // Open modal helper (reusable)
    // -----------------------
    function openNewsletterModal(prefillEmail = '') {
        hideAlert();

        modalForm.classList.remove('was-validated');
        setConsentValidity(true);
        setSubmitting(false);

        modalForm.reset();

        // prefill email (se arriva dal footer)
        if (nmEmail) nmEmail.value = (prefillEmail || '').trim();

        // reset anti-double-submit
        if (nmSubmit) {
            nmSubmit.disabled = false;
            nmSubmit.dataset.loading = '0';
        }

        bsModal.show();

        // focus smart
        setTimeout(() => {
            const emailValue = nmEmail?.value?.trim();
            if (emailValue) {
                nmFname?.focus();
            } else {
                nmEmail?.focus();
            }
        }, 150);
    }

    // -----------------------
    // Footer trigger (prefill email)
    // -----------------------
    openBtn?.addEventListener('click', () => {
        const ok = inlineValidateEmail();
        if (!ok) return;
        openNewsletterModal(inlineEmail.value);
    });

    inlineEmail?.addEventListener('input', () => {
        if (inlineEmail.value.length > 2) inlineValidateEmail();
    });

    // -----------------------
    // CTA triggers (no prefill)
    // Add class "js-open-newsletter-modal" to any CTA button/link
    // -----------------------
    document.querySelectorAll('.js-open-newsletter-modal').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            openNewsletterModal('');
        });
    });

    // -----------------------
    // Submit handler (AJAX)
    // -----------------------
    modalForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        hideAlert();

        // consent validation
        const consentChecked = modalForm.querySelector('input[name="consent"]:checked');
        modalForm.classList.add('was-validated');

        const consentOk = !!consentChecked;
        setConsentValidity(consentOk);

        const formOk = modalForm.checkValidity() && consentOk;
        if (!formOk) return;

        // evita submit multipli
        if (nmSubmit?.dataset.loading === '1') return;
        if (nmSubmit) nmSubmit.dataset.loading = '1';

        // UX: disabilita form + spinner nel bottone
        setSubmitting(true);

        try {
            const payload = new URLSearchParams();
            payload.append('action', 'fsr_newsletter_subscribe');
            payload.append('nonce', FSR_AJAX?.nonce || '');
            payload.append('email', nmEmail?.value?.trim() || '');
            payload.append('first_name', nmFname?.value?.trim() || '');
            payload.append('last_name', nmLname?.value?.trim() || '');
            payload.append('organization', nmOrg?.value?.trim() || '');
            payload.append('country', nmCountry?.value?.trim() || ''); // name-only
            payload.append('consent', consentChecked?.value || '');
            payload.append('website', honeypot?.value || '');

            const res = await fetch(FSR_AJAX?.ajax, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                body: payload.toString(),
                credentials: 'same-origin',
            });

            const data = await res.json();

            if (!data || !data.success) {
                const msg = data?.data?.message || 'Something went wrong. Please try again later.';
                showAlert('danger', msg);

                setSubmitting(false);
                if (nmSubmit) nmSubmit.dataset.loading = '0';
                return;
            }

            // SUCCESS
            showAlert('success', data.data.message || 'Thanks! Please check your inbox to confirm your subscription.');

            // reset form (così l'utente capisce che è andata)
            modalForm.reset();
            inlineForm?.reset();
            inlineEmail?.classList.remove('is-valid', 'is-invalid');
            modalForm.classList.remove('was-validated');

            // tieni la modale aperta abbastanza per leggere
            const CLOSE_AFTER_MS = 3800;

            setTimeout(() => {
                bsModal.hide();
                hideAlert();
                setSubmitting(false);
                if (nmSubmit) nmSubmit.dataset.loading = '0';
            }, CLOSE_AFTER_MS);
        } catch (err) {
            showAlert('danger', 'Network error. Please try again.');

            setSubmitting(false);
            if (nmSubmit) nmSubmit.dataset.loading = '0';
        }
    });
}